(function () {
    'use strict';

    angular
        .module('riskEditModule')
        .controller('RiskRelatedControlsController', Controller);

    Controller.$inject = ['$scope', 'historyCtxtService', 'grcRiskService', 'risk', 'controls'];

    function Controller($scope, historyCtxtService, grcRiskService, risk, controls) {

        $scope.controls = controls;

        // Control
        $scope.goToControl = function (control) {
            historyCtxtService.goToState('control',
                { ControlID: control.ControlID },
                'riskEdit',
                risk
            );
        };

        // Add a new related control
        $scope.addControl = function (control) {

            grcRiskService.addControlToRisk($scope.risk.RiskID, control.ControlID)
            .then(function (controls) {
                $scope.risk.Controls = controls;
                $scope.controls = controls;
            });
        };

        // Unlink a control
        $scope.unlinkControl = function (control) {

            grcRiskService.removeControlFromRisk($scope.risk.RiskID, control.ControlID)
            .then(function () {
                $scope.risk.Controls = _.reject($scope.risk.Controls, { ControlID: control.ControlID });
                $scope.controls = _.reject($scope.controls, { ControlID: control.ControlID });
            });
        }
    }
})();